import { makeStyles } from "@material-ui/styles"
const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    minWidth: CELL_WIDTHS.TITLE_NORMAL,
    color: theme.palette.text.primary,
  },
  isSticky: {
    left: CELL_WIDTHS.DRAG_HANDLE,
    zIndex: 4,
    position: "sticky",
  },
  staticWidth: {
    maxWidth: CELL_WIDTHS.TITLE_NORMAL,
  },
  wider: {
    minWidth: CELL_WIDTHS.TITLE_LARGE,
    "&$staticWidth": {
      maxWidth: CELL_WIDTHS.TITLE_LARGE,
    }
  },
  resizeable: {
    zIndex: ({ colName }) => `var(--index-${colName})`,
    minWidth: ({ colName }) => `var(--minWidth-${colName})`,
    maxWidth: ({ colName }) => `var(--maxWidth-${colName})`,
  },
  pinnedLeft: {
    left: ({ colName }) =>  `var(--left-${colName})`,
  },
  resizeableKeepMinSize: {
    maxWidth: ({ colName }) => `var(--minWidth-${colName})`,
  },
  keepMinSize: {
    maxWidth: ({ tableDepth }) => `calc(${CELL_WIDTHS.TITLE_NORMAL}px - ${(tableDepth - 1) * CELL_WIDTH_DEPTH_MODIFIER}px)`,
  },
  keepSmallestSize: {
    minWidth: CELL_WIDTHS.TITLE_SMALLER,
  }
}));

import { CELL_WIDTH_DEPTH_MODIFIER, CELL_WIDTHS } from "@utils";

export default useStyle;
